import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { change } from 'redux-form';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import {
  generateITineraryIncidentPath,
  ITINERARY_INCIDENT_PATH,
} from '../../../../config/paths';
import IncidentRecordForm from './IncidentRecordForm';
import {
  postItineraryIncidentRecord,
  getIncidentsForForm,
  clearIncidentsForForm,
} from '../../../../actions/supervision-control';
import { INCIDENT_SCOPE_TYPE } from '../../../../config/constants';
import { tzMergeDateAndTime, tzNormalizeDate } from '../../../../utils/date';
import { TIME_FORMAT } from '../../../../config/locale';

const NewItineraryIncident = ({
  match: {
    params: { itineraryId, segmentId },
  },
  breadcrumbs,
  dispatchPostItineraryIncidentRecord,
  dispatchPush,
  dispatchGetIncidentsForForm,
  dispatchClearIncidentsForForm,
  dispatchChange,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearIncidentsForForm();
    },
    [],
  );

  const handleSubmit = async (formValues) => {
    const {
      incidentId,
      nodePathsPerRow,
      incidentItems,
      dateString,
      timeString,
      incidentRecordType,
    } = formValues;

    const incidentDate = tzMergeDateAndTime({
      date: dateString,
      time: timeString,
    });

    const answerList = incidentItems.flatMap((rowValues, rowIndex) => {
      const fieldPrefix = `incidentItems[${rowIndex}]`;
      const nodePath = nodePathsPerRow[`${fieldPrefix}.nodeSelector`] || [];

      return nodePath.map((node, pathIndex) => {
        const note = rowValues[`incidentNodeNote-${pathIndex}`] || null;
        const answer = { nodeId: node.id };
        if (note) answer.note = note;
        return answer;
      });
    });

    const payload = {
      incidentId,
      incidentDate,
      itineraryId: itineraryId ? Number(itineraryId) : null,
      segmentId: segmentId ? Number(segmentId) : null,
      agencyId: null,
      answerList,
      incidentRecordType: incidentRecordType ? incidentRecordType.value : null,
    };

    await dispatchPostItineraryIncidentRecord(payload);
    dispatchPush(generateITineraryIncidentPath({ itineraryId, segmentId }));
  };

  const handleIncidentRecordTypeChange = (incidentRecordTypeForm) => {
    if (!incidentRecordTypeForm) return;
    const { value: incidentRecordType } = incidentRecordTypeForm;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i <= 10; i++) {
      dispatchChange('IncidentRecordForm', `incidentNode-${i}`, null);
      dispatchChange('IncidentRecordForm', `incidentNodeNote-${i}`, null);
    }

    dispatchGetIncidentsForForm({
      itineraryId,
      segmentId,
      incidentRecordType,
    });
  };

  const content = (
    <IncidentRecordForm
      onSubmit={handleSubmit}
      incidentScope={INCIDENT_SCOPE_TYPE.ITINERARY.value}
      handleIncidentRecordTypeChange={handleIncidentRecordTypeChange}
      allowDuplicateNodes
      initialValues={{
        dateString: tzNormalizeDate(),
        timeString: tzNormalizeDate({ format: TIME_FORMAT })
      }}
    />
  );

  return (
    <Content
      title="Nuevo Incidente de Itinerario"
      subtitle="Registra un nuevo incidente para este itinerario"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  );
};

NewItineraryIncident.propTypes = {
  match: matchPropTypes.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostItineraryIncidentRecord: PropTypes.func.isRequired,
  dispatchPush: PropTypes.func.isRequired,
  dispatchGetIncidentsForForm: PropTypes.func.isRequired,
  dispatchClearIncidentsForForm: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
};

NewItineraryIncident.defaultProps = {};

const mapStateToProps = ({ SupervisionControlUnit }, ownProps) => {
  const { itineraryId, segmentId } = ownProps.match.params;
  return {
    breadcrumbs: [
      ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
      {
        text: 'Incidentes en Itinerarios',
        href: ITINERARY_INCIDENT_PATH,
      },
      {
        text: 'Incidentes en Itinerario',
        href: generateITineraryIncidentPath({ itineraryId, segmentId }),
      },
      {
        text: 'Nuevo',
        href: '',
      },
    ],
    incidentForForm: SupervisionControlUnit.Incident.getIn([
      'incidentForForm',
      'content',
    ]),
    loading: SupervisionControlUnit.Incident.getIn([
      'incidentForForm',
      'loading',
    ]),
  };
};

const mapDispatchToProps = {
  dispatchPush: push,
  dispatchPostItineraryIncidentRecord: postItineraryIncidentRecord,
  dispatchGetIncidentsForForm: getIncidentsForForm,
  dispatchClearIncidentsForForm: clearIncidentsForForm,
  dispatchChange: change,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewItineraryIncident);
